"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "palizzi": {
    "0bd9b8f5": [{
      "hkey": "0528d745",
      "slug": "palizzi",
      "name": "Palizzi",
      "primary": true,
      "skipSearch": false
    }],
    "case-sparse": [{
      "hkey": "0528d745",
      "slug": "palizzi",
      "name": "Palizzi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f9676aa5": [{
      "hkey": "0528d745",
      "slug": "palizzi",
      "name": "Palizzi",
      "primary": true,
      "skipSearch": false
    }],
    "contrada-iermanata": [{
      "hkey": "0528d745",
      "slug": "palizzi",
      "name": "Palizzi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c395e2dc": [{
      "hkey": "f96a121c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "palizzi-superiore": [{
      "hkey": "f96a121c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;